import { IconCheck, IconChevronDown } from '@tabler/icons-react';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { Menu, Pressable } from '@cfa/react-core';

import ToggleSwitch from './ToggleSwitch';

import { ChatModelInfo } from '@/_generated/api-clients/xp';
import { useChatModels } from '@/routes/smart-search/hooks/useChatModels';
import { extendedReasoningAtom } from '@/routes/smart-search/state';

const ModelSelect: React.FC = () => {
  const { t } = useTranslation();
  const { models, selected, selectModel } = useChatModels();
  const [extendedReasoning, setExtendedReasoning] = useAtom(
    extendedReasoningAtom,
  );

  if (!selected) return null;

  return (
    <Menu.Root>
      <Pressable>
        <button
          type="button"
          className="hover:bg-grayscale-gray2/30 flex cursor-pointer items-center gap-0.5 rounded-lg px-2! py-1! transition-colors"
        >
          <span className="text-variant-body2 mr-0.5">
            {selected.displayName}
          </span>{' '}
          {extendedReasoning && (
            <span className="text-variant-body2 text-brand-dark-gray/70">
              {t('chat.reasoning.extended')}
            </span>
          )}
          <IconChevronDown size={20} />
        </button>
      </Pressable>
      <Menu.Popover placement="top right" className="rounded-xl!">
        <Menu.Container className="p-1">
          {models
            .filter((m): m is ChatModelInfo & { key: string } => Boolean(m.key))
            .map(model => (
              <Menu.Item
                key={model.key}
                textValue={model.displayName}
                onAction={() => selectModel(model.key)}
                className="hover:bg-grayscale-gray2/30! text-variant-body2! rounded-lg px-2.5! py-1.5! transition-colors"
              >
                {model.displayName}
                {model.key === selected.key && (
                  <IconCheck size={18} className="text-brand-navy!" />
                )}
              </Menu.Item>
            ))}
        </Menu.Container>
        <Menu.Divider className="my-1!" />
        <div className="hover:bg-grayscale-gray2/30! m-1 flex cursor-pointer items-center gap-4 rounded-lg px-3 py-2 transition-colors">
          <div className="flex flex-col justify-center">
            <p className="text-variant-body2">
              {t('chat.reasoning.extendedReasoning')}
            </p>
            <p className="text-variant-caption2! text-grayscale-gray6">
              {t('chat.reasoning.extendedReasoningDescription')}
            </p>
          </div>
          <ToggleSwitch
            isSelected={extendedReasoning}
            onChange={setExtendedReasoning}
            aria-label={t('chat.reasoning.extendedReasoning')}
          />
        </div>
      </Menu.Popover>
    </Menu.Root>
  );
};

export default ModelSelect;
